import React, { useEffect } from 'react'
import ProgressCircle from 'components/ProgressCircle/ProgressCircle'
import { Box } from '@material-ui/core'
import { useStyles } from './SignInRedirection_style'
import URLParamsHandler from 'assets/URLParamsHandler'
import URLHandler from 'assets/URLHandler'
import AnalyticsHelper from 'assets/AnalyticsHelper'

const SignInRedirection = (props) => {
    const { user } = props
    const classes = useStyles()

    const parsedParams = URLParamsHandler.parseURLParams()
    const origin = parsedParams.origin
    const provider = parsedParams.provider
    const primaryRedirection = URLHandler.RemoveQueryString(parsedParams.primary_redirection)
    const finalRedirection = URLHandler.RemoveQueryString(parsedParams.final_redirection)
    const redirectionType = parsedParams.redirection_type
    const queryString = URLParamsHandler.stringifyURLParams(parsedParams)

    useEffect(() => {
        if (redirectionType === 'registration') {
            AnalyticsHelper.sendGTMEvent(
                'Create Account Started',
                AnalyticsHelper.constructLoginAnalyticsAttributes(user, provider, origin)
            )
        } else {
            AnalyticsHelper.sendGTMEvent(
                'Login',
                AnalyticsHelper.constructLoginAnalyticsAttributes(user, provider, origin)
            )
        }

        setTimeout(() => {
            window.location.href = `${primaryRedirection}?${queryString}&redirect=${finalRedirection}`
        }, 1000)
    }, [])

    return (
        <Box className={classes.container}>
            <ProgressCircle />
        </Box>
    )
}

export default SignInRedirection
